import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { PackageService } from '../../common/package.service';
import { FeatureService } from '../../common/feature.service';
import { FeatureLimitFormComponent } from '../feature-limit-form/feature-limit-form.component';
import { MdDialog } from '@angular/material';

@Component({
  selector: 'package-feature-limits',
  templateUrl: './package-feature-limits.component.html',
  styleUrls: ['./package-feature-limits.component.css'],
  providers: [FeatureService,PackageService],
})
export class PackageFeatureLimitsComponent implements OnInit {

  eventId: any;
  packageId: any;
  featureId: any;
  featureLimits: any;
  featureLimitId: any;
  spinner: boolean = false;

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private featureService: FeatureService, private packageService: PackageService, public dialog: MdDialog){
  }

  ngOnInit() {
  }

  getFeatureLimits(){
   this.packageService.getFeatureLimits(this.packageId).subscribe(
    response => {
     this.featureLimits = response;
     this.spinner = false;
    },
    error => {
     this.spinner = false;
    }
   );
  }

  featureLimitFormDialog(params) {
    if(params && params.id)
    this.featureLimitId = params.id;
    else
    this.featureLimitId = 0;
    let dialogRef = this.dialog.open(FeatureLimitFormComponent);
    dialogRef.componentInstance.eventId = this.featureLimitId;
    this.featureService.getFeatures(this.eventId).subscribe(response => {
     dialogRef.componentInstance.features = response;
    });
    dialogRef.componentInstance.packageId = this.packageId;
    dialogRef.componentInstance.featureLimitId = this.featureLimitId;
    if(this.featureLimitId)
    {
     this.packageService.findFeatureLimit(this.featureLimitId).subscribe(response => {
      dialogRef.componentInstance.featureLimit = response[0];
     });
    }
    else
    dialogRef.componentInstance.featureLimit = dialogRef.componentInstance.featureLimitForm.value;
    dialogRef.componentInstance.onSave.subscribe(() => {
     this.getFeatureLimits();
     dialogRef.close();
    });
  }

  deleteFeatureLimit(params){
   this.spinner = true;
   if(confirm('Are you sure?'))
   this.packageService.deleteFeatureLimit(params).subscribe(response => {
    if(response.status)
    this.getFeatureLimits();
   });
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/package-feature-limits/package-feature-limits.component.ts